import { OrgMemberDetail } from "@garther/interfaces";
import { useNavigate } from "@tanstack/react-router";
import { useCallback, useState } from "react";

// TODO: replace direct orgApiClient call with useOrgsByUserQuery from @garther/query-hooks
import { orgApiClient } from "@/shared/libs/api";

const SELECTED_ORG_KEY = "selected_org_id";

export function getCachedOrgId(): string | null {
  return sessionStorage.getItem(SELECTED_ORG_KEY) || localStorage.getItem(SELECTED_ORG_KEY);
}

export function setCachedOrgId(orgId: string): void {
  sessionStorage.setItem(SELECTED_ORG_KEY, orgId);
  localStorage.setItem(SELECTED_ORG_KEY, orgId);
}

export function useNavigateToOrg() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const navigateToOrg = useCallback(
    async (userId: string) => {
      setLoading(true);
      try {
        const orgs: OrgMemberDetail[] = await orgApiClient.getListByUserId(userId);

        if (orgs.length === 0) {
          navigate({ to: "/org/create" });
          return;
        }

        const cachedId = getCachedOrgId();
        const cachedOrg = cachedId ? orgs.find((m) => m.org.id === cachedId) : undefined;

        if (cachedOrg) {
          navigate({ to: "/org/$orgId", params: { orgId: cachedOrg.org.id } });
        } else {
          const firstOrgId = orgs[0].org.id;
          setCachedOrgId(firstOrgId);
          navigate({ to: "/org/$orgId", params: { orgId: firstOrgId } });
        }
      } finally {
        setLoading(false);
      }
    },
    [navigate]
  );

  return { loading, navigateToOrg };
}
